import React from 'react';
import { FormattedMessage } from 'react-intl';

import { HelpButton } from '../../../atoms/help-button';
import { ValueBox } from '../../../molecules/value-box';
import { FormattedValue } from '../../../store/formatted-value';
import { useSelector } from '../../../store/utils';
import { Inverter } from '../../../../../core/src/shared/enums';

export const SettingsOverflowInfo = () => {
  const fronius = useSelector((s) => {
    const inverterConfig = s.variables.INVERTER_CONFIG;
    if (!inverterConfig) return false;
    const inverters = Object.values(inverterConfig);
    return inverters.some((inv) => inv.type === Inverter.Fronius);
  });

  const onGrid = useSelector((s) => {
    return s.variables.PV_ONGRID;
  });

  if (fronius || onGrid) return null;

  return (
    <ValueBox
      type="row"
      title={
        <>
          <FormattedMessage
            id="settings.other.overflow_settings"
            defaultMessage="Nastavená hodnota přetoků"
          />
          <HelpButton
            variant="dialog"
            title={
              <FormattedMessage
                id="settings.other.overflow_settings"
                defaultMessage="Nastavená hodnota přetoků"
              />
            }
            content={
              <FormattedMessage
                id="settings.other.overflow_settings.help"
                defaultMessage="Jedná se o servisně nastavenou hodnotu maximálního přetoku. Tato hodnota je stanovena distributorem. Překročení této hodnoty může vést k finančním postihům ze strany distributora."
              />
            }
          />
        </>
      }
      value={
        <FormattedValue
          variableId="OVERFLOW_INFO"
          opts={{
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
          }}
        />
      }
    />
  );
};
